import Vue from 'vue'
import VueRouter from 'vue-router'
import routes, { ROUTE_NAME_HOME, ROUTE_NAME_PAYMENTS, ROUTE_NAME_SUBSCRIPTIONS } from '@/router/routes'
import { isGrantedRoute } from '@/utils/security'

const MyLayout = () => import(/* webpackChunkName: "app-layout" */'layouts/MyLayout')

Vue.use(VueRouter)

const router = new VueRouter({
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    {
      path: '/',
      component: MyLayout,
      children: routes
    }
  ],

  // Leave these as they are and change in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  mode: process.env.VUE_ROUTER_MODE,
  base: process.env.VUE_ROUTER_BASE
})

/**
 * Liste des routes libres d'accés
 * @type {(string)[]}
 */
const ROUTES_FREE = [ROUTE_NAME_HOME, ROUTE_NAME_PAYMENTS, ROUTE_NAME_SUBSCRIPTIONS]

router.beforeEach((to, from, next) => {
  if (ROUTES_FREE.indexOf(to.name) === -1) {
    if (to.matched.some((r) => !isGrantedRoute(r))) {
      // toast.negative('Accès refusé')
      return next(from.name !== null
        ? false
        : { name: ROUTE_NAME_HOME })
    }
  }
  next()
})

export default router
